import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../components/CustomButton";

AlreadyInPackingModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleIsValid: PropTypes.func.isRequired
};

function AlreadyInPackingModal({open, handleClose, handleIsValid}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.packing.modal.alreadyInPacking.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.alreadyInPacking.subtitle"}/>}
        >
            <Grid container direction={"column"} gap={"8px"}>
                <CustomButton
                    color={"blue"}
                    fullWidth
                    onClick={handleIsValid}
                >
                    <FormattedMessage id={"wms.packing.modal.alreadyInPacking.valid"}/>
                </CustomButton>

                <CustomButton
                    color={"red"}
                    fullWidth
                    onClick={handleClose}
                >
                    <FormattedMessage id={"wms.packing.modal.alreadyInPacking.cancel"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default AlreadyInPackingModal;